// The gov.md strip: the state emblem, "Guvernul Republicii Moldova", and the
// three languages inline on the same row.
//
// MUD's `.top-section` (node `1144:15205`, `mud/components/header.md:74`) — the
// government strip above the header, 32 tall — drawn to the wireframe's
// `.topstrip` (`wireframes/react/src/pages/Autentificare.tsx:38`, `Rol.tsx:11`,
// `EroareAutorizare.tsx:8`, styled at `styles/mud.css:1139`).
//
// Rendered by BOTH shells, so it is on every screen in the system. The wireframe
// draws it on the anonymous pages only, and that reading held until the owner's
// ruling of 2026-09-09; MUD is the deciding source, and it puts the strip above
// `header-general-*`, whose `👤 User State` is Anonymous OR Authenticated. See
// `specs/032-govmd-bar/spec.md §How this came to be asked three times`.
//
// AGE ships no component for this bar and no coat of arms — not an icon in any
// of the four sizes, not a `mud-logo` asset (all 55 are M-family service marks),
// and the footer AGE used to ship rendered "Guvernul Republicii Moldova" as the
// letters "GR" in a box. The emblem below is the official Government seal that has been
// in this repository since the first frontoffice commit.
// per docs/ui-shape-govmd-bar.md §The strip
import { useTranslate } from '@tolgee/react';
import { LanguageSwitcher } from './LanguageSwitcher';

export function GovBar(): JSX.Element {
  const { t } = useTranslate();

  return (
    <div className="simsm-govbar">
      <div className="simsm-govbar__row">
        {/* Decorative: the words beside it name the emblem, in the reader's own
            language, so announcing it as well says the same thing twice. */}
        <img
          className="simsm-govbar__arms"
          src="/brand/gov-md-mark.jpg"
          alt=""
          width={20}
          height={20}
        />
        <span className="simsm-govbar__text">{t('gov_bar.government')}</span>
        <LanguageSwitcher />
      </div>
    </div>
  );
}
